<template>
  <div id="ServicesCard" :class="item.item_slug">
    <div class="backgroundContainer" :style="{ backgroundImage: 'url(' + item.featured_img + ')' }"></div>
    <div class="overlay" @click="goToContent" :style="{backgroundImage: `url('/img/vectors/${vector}.png')`}">
      <div class="textContainer">
        <div
            class="tileLabel lightCardText"
            :style="{fontSize: sizing.tileLabel, lineHeight: sizing.tileLabel}"
        >{{ item.label }}</div>
        <div
            v-if="subtitle"
            class="subtitle lightCardText"
            :style="{fontSize: sizing.subtitle}"
        >{{ subtitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import config from "@/config/constants";

export default {
  name: "ServicesCard",
  props: ["item","tileHeight","index"],
  methods: {
    submitSamlResponse(samlResponse, acsUrl) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = acsUrl;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'SAMLResponse';
      input.value = samlResponse;

      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    },
    async getBenefitsUrl() {
      if(this.$store.getters.skin === 25 && this.$store.getters.user.access_code_user){
        window.location.href = 'https://spectrumbenefits.benefithub.com/';
      } else {
        const slPayload = {
          user_id: this.$store.getters.user_id,
        };
        let slRes = await axios.post(
            config.api_env + "/application/api/p/saml/sso",
            slPayload,
            config.options
        );
        this.submitSamlResponse(slRes.data.samlResponse, slRes.data.acsUrl);
      }
    },
    goToContent() {
      if (this.item.external_link) {
        window.open(this.item.external_link, "_blank");
      } else if(this.item.internal_link) {
        window.open(this.item.internal_link, "_blank");
      } else if(this.$store.getters.skin === 30 && this.item.item_slug === 'rewards') {
        this.getBenefitsUrl();
      } else {
        this.$router.push({name: this.item.item_slug})
      }
    },
  },
  computed: {
    vector() {
      if(this.$store.getters.skin === 36) return 'blue';
      let i = this.index;
      if(i >= 13) {
        i = i - 13;
      }
      switch (i) {
        case 0:
          return 'purple';
        case 1:
          return 'dark-blurple';
        case 2:
          return 'green';
        case 3:
          return 'blue';
        case 4:
          return 'orange';
        case 5:
          return 'grey';
        case 6:
          return 'blurple';
        case 7:
          return 'light-blue';
        case 8:
          return 'lilac';
        case 9:
          return 'light-green';
        case 10:
          return 'dark';
        case 11:
          return 'pink';
        case 12:
          return 'rose';
        default:
          return 'blue';
      }
    },
    subtitle() {
      return this.item.carousel_description ? this.item.carousel_description : this.item.description;
    },
    sizing() {
        return {
          subtitle: Math.floor(this.tileHeight * 0.035) + 'px',
          tileLabel:  Math.floor(this.tileHeight * 0.0525) + 'px',
        }
    },
  }
}

</script>
<style lang="less">
#ServicesCard {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  .lightCardText {
    color: white;
  }
  .backgroundContainer {
    position: absolute;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 15px;
    overflow: hidden;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 1;
  }
  .overlay {
    opacity: 1;
    height: 80%;
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 3;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom;
    .textContainer {
      opacity: 1;
      color: #122130;
      position: absolute;
      top: 60%;
      left: 5%;
      right: 5%;
      bottom: 5%;
      z-index: 4;
      display: flex;
      flex-direction: column;
      .subtitle {
        margin-top: 4px;
        opacity: 0.9;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .tileLabel {
        font-family: FilsonProBold, Arial, Helvetica, sans-serif;
      }
    }
  }
  &.digitalGym {
    .backgroundContainer {
      background-position: 92%;
    }
  }
}
</style>
